import DDMatchMedia       from 'dd-match-media';
import mediaQuerySettings from '../../sass/js-variables/media-query-settings';

const matchMedia = new DDMatchMedia(mediaQuerySettings);

export default matchMedia;


// WEBPACK FOOTER //
// ./src/js/manager/matchMedia.js